import styled from "styled-components";
import { SearchButton } from "../../../../../components/Forms/Common/style";

export const SubmitButton = styled(SearchButton)`
  margin: 0;
  width: 214px;
`;
